import { useState } from "react";

interface SignInPageProps {
  onSignIn: () => Promise<void>;
}

export function SignInPage({ onSignIn }: SignInPageProps) {
  const [error, setError] = useState<string | null>(null);
  const [signing, setSigning] = useState(false);

  const handleClick = async () => {
    setError(null);
    setSigning(true);
    try {
      await onSignIn();
      // Supabase OAuth redirects away from the page; we won't reach here.
    } catch (e) {
      setError(e instanceof Error ? e.message : "Sign-in failed. Please try again.");
      setSigning(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#fafaf7] flex items-center justify-center p-6">
      <div className="max-w-sm w-full text-center">
        <div className="text-xs font-bold tracking-widest text-rwb-red mb-2">TEAM RWB</div>
        <h1 className="text-2xl font-semibold text-zinc-900 mb-2">
          Activity Tracking Testing Portal
        </h1>
        <p className="text-sm text-zinc-500 mb-8">
          Sign in with your Team RWB Google account to see today's checks.
        </p>

        <button
          onClick={handleClick}
          disabled={signing}
          className="inline-flex items-center gap-3 bg-white border border-zinc-200 hover:border-zinc-300 disabled:opacity-60 disabled:cursor-wait px-5 py-2.5 rounded-lg text-sm font-medium text-zinc-800 transition shadow-sm"
        >
          <GoogleLogo />
          {signing ? "Redirecting to Google..." : "Sign in with Google"}
        </button>

        <p className="text-[11px] text-zinc-400 mt-5">@teamrwb.org accounts only</p>

        {error && (
          <div className="mt-6 p-3 rounded-lg bg-rose-50 border border-rose-200 text-xs text-rose-800">
            {error}
          </div>
        )}
      </div>
    </div>
  );
}

function GoogleLogo() {
  return (
    <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden>
      <path
        fill="#FFC107"
        d="M43.6 20.1H42V20H24v8h11.3c-1.7 4.7-6.2 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34.1 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.7-.4-3.9z"
      />
      <path
        fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34.1 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3c-1.9 1.3-4.3 2.1-7.3 2.1-5.1 0-9.5-3.2-11.2-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.1H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.7l6.3 5.3c-.5.4 7.6-5.5 7.6-15-.1-1.4-.2-2.7-.4-3.9z"
      />
    </svg>
  );
}
